import { Phone, EnvelopeSimple, MapPin, ChatText, Heart, FacebookLogo, InstagramLogo, WhatsappLogo } from "@phosphor-icons/react";
import { PHONE, PHONE_RAW, EMAIL, SOCIALS, WHATSAPP, OFFICE } from "../data";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-white pt-16 pb-8 border-t-2 border-sun">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-10 pb-12">
        <div>
          <div className="mb-4">
            <span className="font-display font-extrabold text-4xl sm:text-5xl tracking-tighter text-white leading-none">DS CABS</span>
            <span className="block font-display font-bold text-sm tracking-[0.25em] text-sun mt-2">&amp; DELIVERY INC.</span>
          </div>
          <p className="text-sun font-bold text-xs uppercase tracking-[0.15em] mb-2">DS CABS &amp; Delivery inc. · also known as Windsor Taxi</p>
          <p className="text-white/60 max-w-sm leading-relaxed">
            Windsor's most trusted name in rides &amp; deliveries — serving Windsor, NS &amp; surrounding areas. One call, one text, we do the rest.
          </p>
          <p className="mt-5 inline-flex items-center gap-2 text-sun font-semibold text-sm">
            <Heart weight="fill" size={16} /> Supporting our community, one ride at a time.
          </p>

          <div className="mt-6">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-3">Follow us</p>
            <div className="flex items-center gap-3">
              <a data-testid="social-facebook" href={SOCIALS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"
                className="w-11 h-11 flex items-center justify-center border-2 border-white/20 hover:bg-sun hover:text-ink hover:border-sun text-white transition-colors">
                <FacebookLogo weight="fill" size={22} />
              </a>
              <a data-testid="social-instagram" href={SOCIALS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"
                className="w-11 h-11 flex items-center justify-center border-2 border-white/20 hover:bg-sun hover:text-ink hover:border-sun text-white transition-colors">
                <InstagramLogo weight="fill" size={22} />
              </a>
              <a data-testid="social-whatsapp" href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"
                className="w-11 h-11 flex items-center justify-center border-2 border-white/20 hover:bg-sun hover:text-ink hover:border-sun text-white transition-colors">
                <WhatsappLogo weight="fill" size={22} />
              </a>
            </div>
          </div>
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-4">Get in touch</p>
          <ul className="space-y-3">
            <li><a data-testid="footer-call" href={`tel:${PHONE_RAW}`} className="flex items-center gap-3 hover:text-sun transition-colors"><Phone weight="fill" size={18} className="text-sun" /> {PHONE}</a></li>
            <li><a data-testid="footer-text" href={`sms:${PHONE_RAW}`} className="flex items-center gap-3 hover:text-sun transition-colors"><ChatText weight="fill" size={18} className="text-sun" /> Text us anytime</a></li>
            <li><a data-testid="footer-email" href={`mailto:${EMAIL}`} className="flex items-center gap-3 hover:text-sun transition-colors break-all"><EnvelopeSimple weight="fill" size={18} className="text-sun" /> {EMAIL}</a></li>
            <li className="flex items-start gap-3 text-white/70"><MapPin weight="fill" size={18} className="text-sun shrink-0 mt-0.5" /> {OFFICE}</li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/40 mb-4">Hours</p>
          <p className="font-display font-extrabold text-4xl text-sun tracking-tight">24/7</p>
          <p className="text-white/60 mt-2 leading-relaxed">Always ready — day or night, we're on the road for you.</p>
          <p className="mt-4 text-sm text-white/50">Cash · Debit · Credit · Tap · E-Transfer accepted</p>
        </div>
      </div>

      <div className="pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-sm text-white/40">
        <p>© {new Date().getFullYear()} DS CABS &amp; DELIVERY INC. (Windsor Taxi). All rights reserved.</p>
        <p className="font-semibold text-white/60">Your comfort, our priority.</p>
      </div>
    </div>
  </footer>
);
